import React from 'react';
import i18next from "i18next";
import { Trans, useTranslation } from "react-i18next";
import { Link, useParams } from 'react-router-dom';
import { CheckCircle, Euro, ArrowRight } from 'lucide-react';
export default function EstimationValidationInfo() {
    useTranslation();
    useParams(); // Optionnel maintenant
    return (<div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-6 py-8">
          <h1 className="text-4xl font-light tracking-tight mb-2"><Trans i18nKey="estimationValidation.info.ui.serviceDeValidationDEstimation"/> </h1>
          <p className="text-gray-600 font-light"><Trans i18nKey="estimationValidation.info.ui.commentFaireValiderVotreEstimationParUnExpertArtkiv"/> </p>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-8">
        
        {/* Processus */}
        <div className="bg-white rounded-sm border border-gray-200 p-10 mb-8">
          <h2 className="text-2xl font-light mb-8"><Trans i18nKey="estimationValidation.info.ui.leProcessusEn3Etapes"/></h2>
          
          <div className="space-y-8">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-full bg-black text-white flex items-center justify-center flex-shrink-0 text-xl font-light">
                1
              </div>
              <div>
                <h3 className="text-lg font-medium mb-2"><Trans i18nKey="estimationValidation.info.ui.effectuezVotreEstimation"/></h3>
                <p className="text-gray-700 font-light leading-relaxed mb-3"><Trans i18nKey="estimationValidation.info.ui.utilisezLUneDeNosDeuxMethodesPourCalculer"/> </p>
                <ul className="space-y-2 text-sm text-gray-600">
                  <li className="flex items-start gap-2">
                    <CheckCircle size={16} className="mt-0.5 flex-shrink-0 text-green-600"/>
                    <span><strong><Trans i18nKey="estimationValidation.info.ui.methodeParPoints"/></strong><Trans i18nKey="estimationValidation.info.ui.calculBaseSurLesDimensionsEtLaCoteDe"/></span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle size={16} className="mt-0.5 flex-shrink-0 text-green-600"/>
                    <span><strong><Trans i18nKey="estimationValidation.info.ui.uvresComparables"/></strong><Trans i18nKey="estimationValidation.info.ui.analyseDeVentesSimilairesRecentes"/></span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-full bg-black text-white flex items-center justify-center flex-shrink-0 text-xl font-light">
                2
              </div>
              <div>
                <h3 className="text-lg font-medium mb-2"><Trans i18nKey="estimationValidation.info.ui.demandezLaValidation"/></h3>
                <p className="text-gray-700 font-light leading-relaxed"><Trans i18nKey="estimationValidation.info.ui.uneFoisVotreCalculTermineCliquezSurDemanderUne"/> </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-full bg-black text-white flex items-center justify-center flex-shrink-0 text-xl font-light">
                3
              </div>
              <div>
                <h3 className="text-lg font-medium mb-2"><Trans i18nKey="estimationValidation.info.ui.recevezLEstimationValidee"/></h3>
                <p className="text-gray-700 font-light leading-relaxed"><Trans i18nKey="estimationValidation.info.ui.nosExpertsVerifientVosDonneesConsolidentLesSourcesEt"/> <strong><Trans i18nKey="estimationValidation.info.ui.4872hOuvres"/></strong>.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Tarification */}
        <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-sm border border-blue-200 p-10 mb-8">
          <div className="flex items-start gap-4 mb-6">
            <div className="w-12 h-12 rounded-full bg-blue-600 flex items-center justify-center flex-shrink-0">
              <Euro size={24} className="text-white"/>
            </div>
            <div>
              <h2 className="text-2xl font-light mb-2"><Trans i18nKey="estimationValidation.info.ui.tarificationTransparente"/></h2>
              <p className="text-gray-700 font-light"><Trans i18nKey="estimationValidation.info.ui.lesValidationsNeSontPasAutomatiquementInclusesDansVotre"/> </p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {/* Standard */}
            <div className="bg-white rounded-lg p-6 border-2 border-gray-200">
              <h3 className="text-lg font-semibold mb-3"><Trans i18nKey="estimationValidation.info.ui.abonnementStandard"/></h3>
              <div className="space-y-2 text-sm">
                <div className="flex items-center justify-between py-2 border-b">
                  <span className="text-gray-700"><Trans i18nKey="estimationValidation.info.ui.validationsGratuites"/></span>
                  <span className="font-bold text-green-600"><Trans i18nKey="estimationValidation.info.ui.10Mois"/></span>
                </div>
                <div className="flex items-center justify-between py-2">
                  <span className="text-gray-700"><Trans i18nKey="estimationValidation.info.ui.auDelaDuQuota"/></span>
                  <span className="font-bold"><Trans i18nKey="estimationValidation.info.ui.150Validation"/></span>
                </div>
              </div>
            </div>

            {/* Premium */}
            <div className="bg-white rounded-lg p-6 border-2 border-blue-500">
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-lg font-semibold"><Trans i18nKey="estimationValidation.info.ui.abonnementPremium"/></h3>
                <span className="px-2 py-1 bg-blue-100 text-blue-700 text-xs font-semibold rounded"><Trans i18nKey="estimationValidation.info.ui.recommande"/> </span>
              </div>
              <div className="space-y-2 text-sm">
                <div className="flex items-center justify-between py-2 border-b">
                  <span className="text-gray-700"><Trans i18nKey="estimationValidation.info.ui.validationsGratuites"/></span>
                  <span className="font-bold text-green-600"><Trans i18nKey="estimationValidation.info.ui.50Mois"/></span>
                </div>
                <div className="flex items-center justify-between py-2">
                  <span className="text-gray-700"><Trans i18nKey="estimationValidation.info.ui.auDelaDuQuota"/></span>
                  <span className="font-bold"><Trans i18nKey="estimationValidation.info.ui.150Validation"/></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Ce qui est inclus */}
        <div className="bg-white rounded-sm border border-gray-200 p-10 mb-8">
          <h2 className="text-2xl font-light mb-6"><Trans i18nKey="estimationValidation.info.ui.ceQuiEstInclusDansLaValidation"/></h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="flex items-start gap-3">
              <CheckCircle size={20} className="text-green-600 flex-shrink-0 mt-0.5"/>
              <div>
                <p className="font-medium mb-1"><Trans i18nKey="estimationValidation.info.ui.verificationDesDonnees"/></p>
                <p className="text-sm text-gray-600 font-light"><Trans i18nKey="estimationValidation.info.ui.controleDeCoherenceDesInformationsSaisies"/> </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <CheckCircle size={20} className="text-green-600 flex-shrink-0 mt-0.5"/>
              <div>
                <p className="font-medium mb-1"><Trans i18nKey="estimationValidation.info.ui.consolidationDesSources"/></p>
                <p className="text-sm text-gray-600 font-light"><Trans i18nKey="estimationValidation.info.ui.verificationEtEnrichissementDesComparables"/> </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <CheckCircle size={20} className="text-green-600 flex-shrink-0 mt-0.5"/>
              <div>
                <p className="font-medium mb-1"><Trans i18nKey="estimationValidation.info.ui.affinementDeLEstimation"/></p>
                <p className="text-sm text-gray-600 font-light"><Trans i18nKey="estimationValidation.info.ui.ajustementsBasesSurLExpertiseDuMarche"/> </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <CheckCircle size={20} className="text-green-600 flex-shrink-0 mt-0.5"/>
              <div>
                <p className="font-medium mb-1"><Trans i18nKey="estimationValidation.info.ui.rapportDetaille"/></p>
                <p className="text-sm text-gray-600 font-light"><Trans i18nKey="estimationValidation.info.ui.documentPdfProfessionnelAvecMethodologie"/> </p>
              </div>
            </div>
          </div>
        </div>

        {/* Engagement transparence */}
        <div className="bg-blue-50 border-l-4 border-blue-500 p-8 mb-8">
          <h3 className="text-xl font-semibold text-blue-900 mb-4"><Trans i18nKey="estimationValidation.info.ui.notreEngagementTransparence"/> </h3>
          <p className="text-sm text-blue-800 font-light leading-relaxed mb-4">
            <strong><Trans i18nKey="estimationValidation.info.ui.artkivNeModifieJamaisVosCalculs"/></strong><Trans i18nKey="estimationValidation.info.ui.notreValidationEnrichitVotreAnalyseAvecDesVentesComplementaires"/> <strong><Trans i18nKey="estimationValidation.info.ui.chaqueAjoutEstJustifie"/></strong><Trans i18nKey="estimationValidation.info.ui.etTraceDansLeRapportFinal"/> </p>
          
          <div className="bg-white rounded-lg p-6 mb-4">
            <h4 className="font-semibold text-blue-900 mb-3"><Trans i18nKey="estimationValidation.info.ui.vousVerrezExactement"/></h4>
            <ul className="space-y-2 text-sm text-blue-800">
              <li className="flex items-start gap-2">
                <span className="font-bold text-blue-600">1.</span>
                <span><strong><Trans i18nKey="estimationValidation.info.ui.votreCalculInitial"/></strong><Trans i18nKey="estimationValidation.info.ui.reproduitTelQuelInchange"/></span>
              </li>
              <li className="flex items-start gap-2">
                <span className="font-bold text-blue-600">2.</span>
                <span><strong><Trans i18nKey="estimationValidation.info.ui.lesVentesAjouteesParArtkiv"/></strong><Trans i18nKey="estimationValidation.info.ui.avecSourcesExactesMaisonDeVentesDateLotEt"/></span>
              </li>
              <li className="flex items-start gap-2">
                <span className="font-bold text-blue-600">3.</span>
                <span><strong><Trans i18nKey="estimationValidation.info.ui.lesVentesEcartees"/></strong><Trans i18nKey="estimationValidation.info.ui.siNecessaireAvecJustificationDetaillee"/></span>
              </li>
              <li className="flex items-start gap-2">
                <span className="font-bold text-blue-600">4.</span>
                <span><strong><Trans i18nKey="estimationValidation.info.ui.lEcartEntreVotreEstimationEtLaNotre"/></strong><Trans i18nKey="estimationValidation.info.ui.avecExplicationMethodologique"/></span>
              </li>
            </ul>
          </div>

          <p className="text-sm text-blue-800 font-light leading-relaxed">
            <strong><Trans i18nKey="estimationValidation.info.ui.notreSeuleMission"/></strong><Trans i18nKey="estimationValidation.info.ui.vousDonnerLEstimationLaPlusJustePossibleBasee"/> </p>
        </div>

        {/* Différence avec expertise CNES */}
        <div className="bg-amber-50 border-l-4 border-amber-500 p-6 mb-8">
          <h3 className="font-semibold text-amber-900 mb-2"><Trans i18nKey="estimationValidation.info.ui.importantValidationVsExpertiseCnes"/> </h3>
          <p className="text-sm text-amber-800 font-light leading-relaxed mb-3"><Trans i18nKey="estimationValidation.info.ui.laValidationDEstimationArtkiv"/> <strong><Trans i18nKey="estimationValidation.info.ui.nEstPas"/></strong><Trans i18nKey="estimationValidation.info.ui.uneExpertiseOfficielleParUnExpertAgreeCnesElle"/> </p>
          <ul className="text-sm text-amber-800 space-y-1 ml-4">
            <li><Trans i18nKey="estimationValidation.info.ui.assurancePourDesUvres80000"/></li>
            <li><Trans i18nKey="estimationValidation.info.ui.gestionDeCollectionPersonnelle"/></li>
            <li><Trans i18nKey="estimationValidation.info.ui.premiereEvaluationAvantVente"/></li>
          </ul>
          <p className="text-sm text-amber-800 font-light mt-3"><Trans i18nKey="estimationValidation.info.ui.pourLesUvresDeHauteValeur80000Ou"/> <strong><Trans i18nKey="estimationValidation.info.ui.expertiseCnes"/></strong><Trans i18nKey="estimationValidation.info.ui.estRecommandeeOuObligatoire"/>{' '}
            <Link to="/fiche/estimation" className="underline font-medium"><Trans i18nKey="estimationValidation.info.ui.enSavoirPlus"/></Link>
          </p>
        </div>
    {/* FAQ Section à ajouter dans EstimationValidationInfo.jsx */}
    {/* Placer AVANT le CTA final "Prêt à estimer votre œuvre" */}

    {/* FAQ */}
    <div className="bg-white rounded-sm border border-gray-200 p-10 mb-8">
  <h2 className="text-2xl font-light mb-8"><Trans i18nKey="estimationValidation.info.ui.questionsFrequentes"/></h2>
  
  <div className="space-y-6">
    
    {/* Question 1 - Transparence */}
    <div className="border-b border-gray-200 pb-6">
      <h3 className="text-lg font-medium mb-3 text-gray-900"><Trans i18nKey="estimationValidation.info.ui.commentPuisJeEtreSurEQuArtkivN"/> </h3>
      <div className="space-y-3 text-sm text-gray-700 font-light leading-relaxed">
        <p>
          <strong><Trans i18nKey="estimationValidation.info.ui.excellenteQuestionEtNousLaComprenonsParfaitement"/></strong><Trans i18nKey="estimationValidation.info.ui.laTransparenceEstAuCUrDeNotreService"/> </p>
        
        <div className="bg-blue-50 rounded-lg p-4 space-y-3">
          <div className="flex items-start gap-3">
            <span className="font-bold text-blue-600 flex-shrink-0">1.</span>
            <div>
              <p className="font-semibold text-blue-900 mb-1"><Trans i18nKey="estimationValidation.info.ui.votreCalculResteIntact"/></p>
              <p className="text-blue-800"><Trans i18nKey="estimationValidation.info.ui.nousReproduisonsExactementVotreEstimationInitialeDansLeRapport"/> </p>
            </div>
          </div>
          
          <div className="flex items-start gap-3">
            <span className="font-bold text-blue-600 flex-shrink-0">2.</span>
            <div>
              <p className="font-semibold text-blue-900 mb-1"><Trans i18nKey="estimationValidation.info.ui.sourcesVerifiables"/></p>
              <p className="text-blue-800"><Trans i18nKey="estimationValidation.info.ui.chaqueVenteAjouteeInclutMaisonDeVentesDateExacte"/> </p>
            </div>
          </div>
          
          <div className="flex items-start gap-3">
            <span className="font-bold text-blue-600 flex-shrink-0">3.</span>
            <div>
              <p className="font-semibold text-blue-900 mb-1"><Trans i18nKey="estimationValidation.info.ui.justificationSystematique"/></p>
              <p className="text-blue-800"><Trans i18nKey="estimationValidation.info.ui.pourChaqueVenteAjouteeNousExpliquonsPourquoiElleEst"/> </p>
            </div>
          </div>
          
          <div className="flex items-start gap-3">
            <span className="font-bold text-blue-600 flex-shrink-0">4.</span>
            <div>
              <p className="font-semibold text-blue-900 mb-1"><Trans i18nKey="estimationValidation.info.ui.aucunConflitDInteret"/></p>
              <p className="text-blue-800"><Trans i18nKey="estimationValidation.info.ui.nousNeTouchonsAucuneCommissionSurVosVentesOu"/> </p>
            </div>
          </div>
        </div>
        
        <p className="pt-2"><Trans i18nKey="estimationValidation.info.ui.notreReputationDependDeNotreHonneteteUnClientInsatisfait"/> </p>
      </div>
    </div>

    {/* Question 2 - Sources utilisées */}
    <div className="border-b border-gray-200 pb-6">
      <h3 className="text-lg font-medium mb-3 text-gray-900"><Trans i18nKey="estimationValidation.info.ui.quellesSourcesDeDonneesUtilisezVousPourEnrichirMon"/> </h3>
      <div className="space-y-3 text-sm text-gray-700 font-light leading-relaxed">
        <p><Trans i18nKey="estimationValidation.info.ui.notreValidationReposeSurUnAccesProfessionnelAPlusieurs"/> </p>
        
        <div className="grid md:grid-cols-2 gap-4 mt-3">
          <div className="bg-gray-50 rounded-lg p-4">
            <p className="font-semibold text-gray-900 mb-2"><Trans i18nKey="estimationValidation.info.ui.basesDeDonneesMondiales"/></p>
            <ul className="space-y-1 text-sm text-gray-700">
              <li>• <strong>Artprice</strong><Trans i18nKey="estimationValidation.info.ui.30mResultatsDeVentes"/></li>
              <li>• <strong>Artnet</strong><Trans i18nKey="estimationValidation.info.ui.ventesInternationalesDepuis1985"/></li>
              <li>• <strong><Trans i18nKey="estimationValidation.info.ui.theArtMarket"/></strong><Trans i18nKey="estimationValidation.info.ui.analysesSectorielles"/></li>
            </ul>
          </div>
          
          <div className="bg-gray-50 rounded-lg p-4">
            <p className="font-semibold text-gray-900 mb-2"><Trans i18nKey="estimationValidation.info.ui.archivesMaisonsDeVentes"/></p>
            <ul className="space-y-1 text-sm text-gray-700">
              <li><Trans i18nKey="estimationValidation.info.ui.christieSSothebySBonhams"/></li>
              <li><Trans i18nKey="estimationValidation.info.ui.artcurialTajanPiasaMillon"/></li>
              <li><Trans i18nKey="estimationValidation.info.ui.cataloguesSpecialisesParArtiste"/></li>
            </ul>
          </div>
          
          <div className="bg-gray-50 rounded-lg p-4">
            <p className="font-semibold text-gray-900 mb-2"><Trans i18nKey="estimationValidation.info.ui.sourcesAcademiques"/></p>
            <ul className="space-y-1 text-sm text-gray-700">
              <li><Trans i18nKey="estimationValidation.info.ui.cataloguesRaisonnesSiDisponibles"/></li>
              <li><Trans i18nKey="estimationValidation.info.ui.publicationsDExpertsSpecialises"/></li>
              <li><Trans i18nKey="estimationValidation.info.ui.archivesGaleriesHistoriques"/></li>
            </ul>
          </div>
          
          <div className="bg-gray-50 rounded-lg p-4">
            <p className="font-semibold text-gray-900 mb-2"><Trans i18nKey="estimationValidation.info.ui.expertiseInterne"/></p>
            <ul className="space-y-1 text-sm text-gray-700">
              <li><Trans i18nKey="estimationValidation.info.ui.expertsDiplomesHistoireDeLArt"/></li>
              <li><Trans i18nKey="estimationValidation.info.ui.specialisationsParPeriode"/></li>
              <li><Trans i18nKey="estimationValidation.info.ui.veilleContinueDuMarche"/></li>
            </ul>
          </div>
        </div>
        
        <p className="pt-3">
          <strong><Trans i18nKey="estimationValidation.info.ui.notreValeurAjoutee"/></strong><Trans i18nKey="estimationValidation.info.ui.nousCroisonsCesSourcesProfessionnellesSouventPayantesOuA"/> </p>
        
        <p><Trans i18nKey="estimationValidation.info.ui.toutesLesVentesAjouteesDansVotreRapportInclurontLa"/> </p>
      </div>
    </div>

    {/* Question 3 - Quota */}
    <div className="border-b border-gray-200 pb-6">
      <h3 className="text-lg font-medium mb-3 text-gray-900"><Trans i18nKey="estimationValidation.info.ui.commentFonctionneLeQuotaMensuelDeValidationsGratuites"/> </h3>
      <div className="space-y-3 text-sm text-gray-700 font-light leading-relaxed">
        <p><Trans i18nKey="estimationValidation.info.ui.chaqueAbonnementInclutUnCertainNombreDeValidationsGratuites"/> </p>
        
        <ul className="space-y-2 ml-4">
          <li className="flex items-start gap-2">
            <span className="text-gray-900 font-bold">•</span>
            <span><strong><Trans i18nKey="estimationValidation.info.ui.standard29Mois"/></strong><Trans i18nKey="estimationValidation.info.ui.10ValidationsGratuites"/></span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-gray-900 font-bold">•</span>
            <span><strong><Trans i18nKey="estimationValidation.info.ui.premium199Mois"/></strong><Trans i18nKey="estimationValidation.info.ui.50ValidationsGratuites"/></span>
          </li>
        </ul>
        
        <div className="bg-amber-50 border-l-4 border-amber-400 p-4 mt-3">
          <p className="text-amber-900 text-sm">
            <strong><Trans i18nKey="estimationValidation.info.ui.important"/></strong><Trans i18nKey="estimationValidation.info.ui.leQuotaSeRenouvelleAutomatiquementLe1erDeChaque"/> </p>
        </div>
        
        <p className="pt-2">
          <strong><Trans i18nKey="estimationValidation.info.ui.auDelaDuQuotae1b639"/></strong><Trans i18nKey="estimationValidation.info.ui.chaqueValidationSupplementaireCoute150QuelQueSoitVotre"/> </p>
        
        <p>
          <strong><Trans i18nKey="estimationValidation.info.ui.astuce"/></strong><Trans i18nKey="estimationValidation.info.ui.siVousFaitesRegulierementPlusDe2ValidationsPayantes"/> </p>
      </div>
    </div>

    {/* Question 4 - Délai */}
    <div className="border-b border-gray-200 pb-6">
      <h3 className="text-lg font-medium mb-3 text-gray-900"><Trans i18nKey="estimationValidation.info.ui.puisJeAvoirUneValidationEnMoinsDe48h"/> </h3>
      <div className="space-y-3 text-sm text-gray-700 font-light leading-relaxed">
        <p><Trans i18nKey="estimationValidation.info.ui.leDelaiStandardEstDe"/> <strong><Trans i18nKey="estimationValidation.info.ui.4872HeuresOuvrees"/></strong><Trans i18nKey="estimationValidation.info.ui.lundiVendrediHorsJoursFeries"/> </p>
        
        <p><Trans i18nKey="estimationValidation.info.ui.pourUne"/> <strong><Trans i18nKey="estimationValidation.info.ui.validationExpress24h"/></strong><Trans i18nKey="estimationValidation.info.ui.nousPouvonsEtudierVotreDemandeAuCasParCas"/> </p>
        
        <ul className="space-y-2 ml-4">
          <li className="flex items-start gap-2">
            <span className="text-gray-900 font-bold">•</span>
            <span><Trans i18nKey="estimationValidation.info.ui.contactezNousA"/> <strong><Trans i18nKey="estimationValidation.info.ui.expertsArtkivCom"/></strong><Trans i18nKey="estimationValidation.info.ui.avantDeFaireLaDemande"/></span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-gray-900 font-bold">•</span>
            <span><Trans i18nKey="estimationValidation.info.ui.supplementDe75Total225OuQuota75"/></span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-gray-900 font-bold">•</span>
            <span><Trans i18nKey="estimationValidation.info.ui.selonDisponibiliteDeNosExpertsPasGaranti"/></span>
          </li>
        </ul>
        
        <p className="pt-2">
          <strong><Trans i18nKey="estimationValidation.info.ui.attention"/></strong><Trans i18nKey="estimationValidation.info.ui.memeEnExpressNousMaintenonsLaMemeQualiteD"/> </p>
      </div>
    </div>

    {/* Question 5 - Que faire après */}
    <div className="border-b border-gray-200 pb-6">
      <h3 className="text-lg font-medium mb-3 text-gray-900"><Trans i18nKey="estimationValidation.info.ui.queFaireAvecLeRapportDeValidationUneFois"/> </h3>
      <div className="space-y-3 text-sm text-gray-700 font-light leading-relaxed">
        <p><Trans i18nKey="estimationValidation.info.ui.leRapportDeValidationArtkivPeutEtreUtilisePour"/> </p>
        
        <div className="grid md:grid-cols-2 gap-4 mt-3">
          <div className="bg-green-50 rounded-lg p-4">
            <p className="font-semibold text-green-900 mb-2"><Trans i18nKey="estimationValidation.info.ui.usagesRecommandes"/></p>
            <ul className="space-y-1 text-sm text-green-800">
              <li><Trans i18nKey="estimationValidation.info.ui.assuranceUvres80000"/></li>
              <li><Trans i18nKey="estimationValidation.info.ui.gestionCollectionPersonnelle"/></li>
              <li><Trans i18nKey="estimationValidation.info.ui.premiereEvaluationAvantVente"/></li>
              <li><Trans i18nKey="estimationValidation.info.ui.partageAvecConseillerPatrimoine"/></li>
              <li><Trans i18nKey="estimationValidation.info.ui.discussionAvecGaleriste"/></li>
              <li><Trans i18nKey="estimationValidation.info.ui.valorisationPatrimoniale"/></li>
            </ul>
          </div>
          
          <div className="bg-red-50 rounded-lg p-4">
            <p className="font-semibold text-red-900 mb-2"><Trans i18nKey="estimationValidation.info.ui.necessiteExpertiseCnes"/></p>
            <ul className="space-y-1 text-sm text-red-800">
              <li><Trans i18nKey="estimationValidation.info.ui.successionDeclarationFiscale"/></li>
              <li><Trans i18nKey="estimationValidation.info.ui.donationActeNotarie"/></li>
              <li><Trans i18nKey="estimationValidation.info.ui.contentieuxJuridique"/></li>
              <li><Trans i18nKey="estimationValidation.info.ui.assuranceUvres800004aa7fe"/></li>
              <li><Trans i18nKey="estimationValidation.info.ui.venteMaisonInternationale"/></li>
              <li><Trans i18nKey="estimationValidation.info.ui.litigeAuthenticite"/></li>
            </ul>
          </div>
        </div>
        
        <p className="pt-2">
          <strong><Trans i18nKey="estimationValidation.info.ui.pourAllerPlusLoin"/></strong><Trans i18nKey="estimationValidation.info.ui.siVotreSituationNecessiteUneExpertiseCnesOfficielleContactez"/> </p>
      </div>
    </div>

    {/* Question 6 - Garantie */}
    <div className="border-b border-gray-200 pb-6">
      <h3 className="text-lg font-medium mb-3 text-gray-900"><Trans i18nKey="estimationValidation.info.ui.queSePasseTIlSiJeNeSuis"/> </h3>
      <div className="space-y-3 text-sm text-gray-700 font-light leading-relaxed">
        <p><Trans i18nKey="estimationValidation.info.ui.votreSatisfactionEstNotrePrioriteSiVousAvezDes"/> </p>
        
        <div className="bg-blue-50 rounded-lg p-4 space-y-3">
          <div className="flex items-start gap-2">
            <span className="font-bold text-blue-600">1.</span>
            <div>
              <p className="font-semibold text-blue-900"><Trans i18nKey="estimationValidation.info.ui.contactezNousSous7Jours"/></p>
              <p className="text-sm text-blue-800"><Trans i18nKey="estimationValidation.info.ui.emailExpertsArtkivComAvecVotreReferenceDeValidation"/> </p>
            </div>
          </div>
          
          <div className="flex items-start gap-2">
            <span className="font-bold text-blue-600">2.</span>
            <div>
              <p className="font-semibold text-blue-900"><Trans i18nKey="estimationValidation.info.ui.echangeAvecLExpertValidateur"/></p>
              <p className="text-sm text-blue-800"><Trans i18nKey="estimationValidation.info.ui.nousOrganisonsUnAppelPourClarifierLesPointsContestes"/> </p>
            </div>
          </div>
          
          <div className="flex items-start gap-2">
            <span className="font-bold text-blue-600">3.</span>
            <div>
              <p className="font-semibold text-blue-900"><Trans i18nKey="estimationValidation.info.ui.correctionSiErreurDeNotrePart"/></p>
              <p className="text-sm text-blue-800"><Trans i18nKey="estimationValidation.info.ui.siNousAvonsFaitUneErreurFactuelleNousCorrigeons"/> </p>
            </div>
          </div>
        </div>
        
        <p className="pt-2">
          <strong><Trans i18nKey="estimationValidation.info.ui.important7cb751"/></strong><Trans i18nKey="estimationValidation.info.ui.unSimpleDesaccordMethodologiqueNeConstituePasUneErreur"/> </p>
      </div>
    </div>

    {/* Question 7 - Confidentialité */}
    <div>
      <h3 className="text-lg font-medium mb-3 text-gray-900"><Trans i18nKey="estimationValidation.info.ui.mesDonneesEtImagesDUvresSontEllesConfidentielles"/> </h3>
      <div className="space-y-3 text-sm text-gray-700 font-light leading-relaxed">
        <p>
          <strong>{i18next.t("estimationValidation.info.ui.absolument")}</strong><Trans i18nKey="estimationValidation.info.ui.laConfidentialiteEstGarantieA100"/> </p>
        
        <ul className="space-y-2 ml-4">
          <li className="flex items-start gap-2">
            <span className="text-green-600 font-bold">✓</span>
            <span>
              <strong><Trans i18nKey="estimationValidation.info.ui.aucunPartageAvecDesTiers"/></strong><Trans i18nKey="estimationValidation.info.ui.vosImagesEtInformationsNeSortentJamaisDArtkiv"/> </span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-green-600 font-bold">✓</span>
            <span>
              <strong><Trans i18nKey="estimationValidation.info.ui.conformiteRgpd"/></strong><Trans i18nKey="estimationValidation.info.ui.toutesVosDonneesSontProtegeesSelonLeReglementEuropeen"/> </span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-green-600 font-bold">✓</span>
            <span>
              <strong><Trans i18nKey="estimationValidation.info.ui.hebergementSecuriseEurope"/></strong><Trans i18nKey="estimationValidation.info.ui.serveursHetznerEnAllemagneChiffrementSauvegardesQuotidiennes"/> </span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-green-600 font-bold">✓</span>
            <span>
              <strong><Trans i18nKey="estimationValidation.info.ui.accesRestreint"/></strong><Trans i18nKey="estimationValidation.info.ui.seulLExpertAssigneAVotreValidationAccedeA"/> </span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-green-600 font-bold">✓</span>
            <span>
              <strong><Trans i18nKey="estimationValidation.info.ui.suppressionALaDemande"/></strong><Trans i18nKey="estimationValidation.info.ui.vousPouvezDemanderLaSuppressionDeVosDonneesA"/> </span>
          </li>
        </ul>
        
        <p className="pt-2"><Trans i18nKey="estimationValidation.info.ui.pourPlusDInformations"/> <a href="/privacy-policy" className="underline hover:text-black"><Trans i18nKey="estimationValidation.info.ui.politiqueDeConfidentialite"/></a>
        </p>
      </div>
    </div>

  </div>
    </div>

        {/* CTA */}
        <div className="bg-black text-white rounded-sm p-8 text-center">
          <h3 className="text-2xl font-light mb-4"><Trans i18nKey="estimationValidation.info.ui.pretAEstimerVotreUvre"/></h3>
          <p className="text-gray-300 mb-6 font-light"><Trans i18nKey="estimationValidation.info.ui.commencezParChoisirVotreMethodeDEstimation"/> </p>
          <Link to={`/estimation`} className="inline-flex items-center gap-2 px-8 py-3 bg-white text-black rounded-sm hover:bg-gray-100 transition font-medium"><Trans i18nKey="estimationValidation.info.ui.commencerLEstimation"/> <ArrowRight size={20}/>
          </Link>
        </div>

      </main>
    </div>);
}
